import Stack from '@mui/material/Stack';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InfoButton from './InfoButton';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';

export default function MoreOptions(props) {
  const { userParams, setUserParams } = props;

  const handleCheckboxChange = (event) => {
    const name = event.target.name;
	const checked = event.target.checked;
    const estobj = {...userParams.moreOptions, [name]: checked};
    setUserParams({...userParams, moreOptions:estobj})
  }

  return (
    <>
        <FieldsetBox component="fieldset" sx={{ mt: 1 }}>
            <LegendStyled>More options</LegendStyled>
            <Stack direction="row" spacing={0}>
                <FormGroup row>
                { Object.keys(userParams.moreOptions).map((opt, i) => (
                    <div key={i}>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={userParams.moreOptions[opt]} 
                                    name={opt} 
                                    sx={{ py: 0 }} 
                                    onChange={handleCheckboxChange}
                                />
                            }
                            label={"Estimate missing"}
                        />
                        <InfoButton
                            edge={false}
                            infoFor={opt}
                        />
                    </div>
                ))}
                </FormGroup>
            </Stack>
        </FieldsetBox>
    </>
  )
}

